<template>
  <div class="container">
    <Spin fix v-if="showLoading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <template v-if="!showLoading">
      <div class="content">
        <div class="top" v-if="!showScanQR">
          <div class="header">
            <a>
              <!-- <img class="logo" src="@/assets/images/logo.jpg"/> -->
              <span class="title">人才服务平台</span>
            </a>
          </div>
        </div>
        <div class="main">
          <!-- <div v-if="!!tenant" class="tenant-title"><a @click="showChangeTenant=true">{{L('当前用户')}}:{{tenant.name}}</a></div> -->
          <!-- <div v-if="!tenant" class="tenant-title"><a @click="showChangeTenant=true">{{L('未选择')}}</a></div> -->
          <div v-if="!showScanQR">
            <Form ref="loginform" :rules="rules" :model="loginModel">
              <FormItem prop="userNameOrEmailAddress">
                <div class="ivu-input-wrapper ivu-input-wrapper-large ivu-input-type">
                  <i class="ivu-icon ivu-icon-ios-person-outline ivu-input-icon ivu-input-icon-normal" style="left: 0"></i>
                  <input v-model="loginModel.userNameOrEmailAddress" autocomplete="off" spellcheck="false" type="text" :placeholder="L('请输入用户名')" class="ivu-input ivu-input-large" style="padding-left: 32px; padding-right: 0" />
                </div>
              </FormItem>
              <FormItem prop="password">
                <div class="ivu-input-wrapper ivu-input-wrapper-large ivu-input-type">
                  <div v-if="switchPassDisFlag">
                    <div v-on:click="SwitchPassDis" style="cursor: pointer">
                      <i class="ivu-icon ivu-icon-ios-eye-off-outline ivu-input-icon ivu-input-icon-normal" style="left: 0"></i>
                    </div>
                    <input v-model="loginModel.password" autocomplete="off" spellcheck="false" type="password" :placeholder="L('请输入密码')" class="ivu-input ivu-input-large" style="padding-left: 32px; padding-right: 0" />
                  </div>
                  <div v-else>
                    <div v-on:click="SwitchPassDis" style="cursor: pointer">
                      <i class="ivu-icon ivu-icon-ios-eye-outline ivu-input-icon ivu-input-icon-normal" style="left: 0"></i>
                    </div>
                    <input v-model="loginModel.password" autocomplete="off" spellcheck="false" type="text" :placeholder="L('请输入密码')" class="ivu-input ivu-input-large" style="padding-left: 32px; padding-right: 0" />
                  </div>
                </div>
              </FormItem>
              <FormItem prop="verifyCode">
                <div class="ivu-input-wrapper ivu-input-wrapper-large ivu-input-type">
                  <i class="ivu-icon ivu-icon-ios-bookmark-outline ivu-input-icon ivu-input-icon-normal" style="left: 0"></i>
                  <input v-model="loginModel.verifyCode" autocomplete="off" spellcheck="false" placeholder="验证码" class="ivu-input ivu-input-large" style="padding-left: 32px; padding-right: 0" />
                  <img :src="'data:image/jpg;base64,' + verifyImg" style="position: absolute; right: 0px; height: 100%" @click="getCode" />
                </div>
              </FormItem>
            </Form>
            <!-- <div>
            <Checkbox v-model="loginModel.rememberMe" size="large">{{L('记住我')}}</Checkbox>
            <a style="float:right;font-size: 14px;margin-top: 3px;">{{L('忘记密码')}}</a>
            </div> -->
            <div style="margin-top: 15px">
              <Button type="primary" @click="login" long size="large">{{ L('登录') }}</Button>
            </div>
          </div>
          <div class="codeImg" v-else>
            <!-- <img class='QRImg' src="data:image/jpeg;base64,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" alt=""> -->
            <div id="dingdingLoginContainer"></div>
            <!-- <div class="refresh">请使用钉钉扫描二维码登录<span @click="refresh">
              <Icon type="md-refresh" size='16' />刷新
            </span></div> -->
          </div>

          <!-- <language-switch></language-switch> -->
        </div>
        <div class="scanWrap">
          <a href="javascript:void(0);" class="scanQR" @click="scanQR">{{ showScanQR?L('账号密码登录'):L('扫码登录') }}</a>
        </div>
      </div>
      <Footer :copyright="L('CopyRight')"></Footer>
      <tenant-switch v-model="showChangeTenant"></tenant-switch>
    </template>
  </div>

</template>
<script>
import { Component, Vue, Inject } from 'vue-property-decorator'
import Footer from '../components/Footer.vue'
import TenantSwitch from '../components/tenant-switch.vue'
import LanguageSwitch from '../components/language-switch.vue'
import iView from 'view-design'
import AbpBase from '../lib/abpbase'
import url from '../lib/url'
import appconst from '../lib/appconst'

@Component({
  components: { Footer, TenantSwitch, LanguageSwitch },
})
export default class Login extends AbpBase {
  loginModel = {
    userNameOrEmailAddress: '',
    password: '',
    verifyCode: '',
    guid: '',
    rememberMe: false,
  }
  showChangeTenant = false
  switchPassDisFlag = true
  showScanQR = false
  showLoading = false

  async getDDCode() {
    let encryptionInfo = this.$route.query.encryptionInfo
    console.log('🚀 ~ Login ~ getDDCode ~ encryptionInfo:', encryptionInfo)
    if (encryptionInfo) {
      encryptionInfo = encryptionInfo.replace(/ /g, '+') // 替换空格为加号
      let data = this.$decryptData(encryptionInfo)
      console.log('🚀 ~ Login ~ getDDCode ~ data:', data)
      this.showLoading = true
      const expireInSeconds = data.ExpireInSeconds
      const encryptedAccessToken = data.EncryptedAccessToken
      const accessToken = data.AccessToken
      // Util.abp.session.userId = data.UserId

      this.handleCodeLogin(accessToken, expireInSeconds, encryptedAccessToken)
    }
  }
  get verifyImg() {
    return this.$store.state.app.verifyCode
  }
  scanQR() {
    this.showScanQR = !this.showScanQR
    if (this.showScanQR) {
      this.ddLoginInit()
    }
  }
  //dd登录
  async handleCodeLogin(accessToken, expireInSeconds, encryptedAccessToken) {
    await this.$store.dispatch({
      // tokenAvth/authenticate
      type: 'app/setLoginInfo',
      data: { accessToken, expireInSeconds, encryptedAccessToken },
    })
    sessionStorage.setItem('rememberMe', this.loginModel.rememberMe ? '1' : '1')
    this.$router.replace({
      path: 'main/home',
    })
    window.location.href = appconst.remoteServiceBaseUrl + '/jzzjf_portal/index.html'
    // window.location.href = 'http://localhost:8080/index.html'
  }

  getUrlCode(name) {
    var str = window.location.hash //获取当前url
    console.log('🚀 ~ Login ~ getUrlCode ~ str:', str)

    if (str.indexOf(name) != -1) {
      var pos_start = str.indexOf(name) + name.length + 1
      var pos_end = str.indexOf('&', pos_start)
      if (pos_end == -1) {
        return str.substring(pos_start)
      } else if (pos_end > 0) {
        return str.substring(pos_start, pos_end)
      } else {
        return ''
      }
    }
  }
  refresh() {}
  //钉钉登录初始化
  async ddLoginInit() {
    let { data } = await this.$Ajax.post('/home/GetLoginPageInitData')
    console.log('🚀 ~ file: login.vue:112 ~ Login ~ ddLoginInit ~ data:', data)
    var appid = data.result.dingDingAppId
    var url = 'https://' + data.result.webDomain + '/Home/DingLoginCallback'
    var obj = DDLogin({
      id: 'dingdingLoginContainer', //这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
      goto: encodeURIComponent(
        'https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=' +
          appid +
          '&response_type=code&scope=snsapi_login&state=&redirect_uri=' +
          url
      ), //请参考注释里的方式
      style: 'border:none;background-color:#FFFFFF;',
      width: '360',
      height: '350',
    })
    let handleMessage = function (event) {
      let origin = event.origin
      console.log('origin', event.origin)
      if (origin == 'https://login.dingtalk.com') {
        //判断是否来自ddLogin扫码事件。
        var loginTmpCode = event.data //拿到loginTmpCode后就可以在这里构造跳转链接进行跳转了
        console.log(
          '🚀 ~ file: login.vue:166 ~ Login ~ handleMessage ~ loginTmpCode:',
          loginTmpCode
        )
        console.log(
          '🚀 ~ file: login.vue:166 ~ Login ~ handleMessage ~ loginTmpCode:',
          loginTmpCode
        )
        console.log(
          '🚀 ~ file: login.vue:166 ~ Login ~ handleMessage ~ loginTmpCode:',
          loginTmpCode
        )
        window.location.href =
          'https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=' +
          appid +
          '&response_type=code&scope=snsapi_login&state=&redirect_uri=' +
          url +
          '&loginTmpCode=' +
          loginTmpCode
      }
    }
    if (typeof window.addEventListener != 'undefined') {
      window.addEventListener('message', handleMessage, false)
    } else if (typeof window.attachEvent != 'undefined') {
      window.attachEvent('onmessage', handleMessage)
    }
  }
  async login() {
    this.$refs.loginform.validate(async (valid) => {
      if (valid) {
        this.$Message.loading({
          content: '登录中',
          duration: 0,
        })
        let _this = this
        _this.loginModel.guid = _this.$store.state.app.guid
        setTimeout(function () {
          _this.getCode()
        }, 500)
        await this.$store.dispatch({
          // tokenAvth/authenticate
          type: 'app/login',
          data: this.loginModel,
        })
        sessionStorage.setItem('rememberMe', this.loginModel.rememberMe ? '1' : '1')
        //  window.location.href=url
        location.reload()
      }
    })
  }
  async getCode() {
    await this.$store.dispatch({
      type: 'app/getVerifyCode',
    })
  }
  SwitchPassDis() {
    this.switchPassDisFlag = !this.switchPassDisFlag
  }
  get tenant() {
    return this.$store.state.session.tenant
  }
  validatePassCheck = (rul, value, callback) => {
    if (!value) {
      callback(new Error('验证码不能为空'))
    } else if (!(value.length == 4)) {
      callback(new Error('只能输入4位数'))
    } else {
      callback()
    }
  }
  rules = {
    userNameOrEmailAddress: [{ required: true, message: this.L('必填信息'), trigger: 'blur' }],
    password: [{ required: true, message: this.L('必填信息'), trigger: 'blur' }],
    verifyCode: [
      { required: true, message: '验证码不能为空', trigger: 'blur' },
      { validator: this.validatePassCheck, message: '只能输入4位数', trigger: 'blur' },
    ],
  }

  mounted() {
    this.getCode()
    this.getDDCode()
  }
  created() {
    //绑定键盘enter事件
    let _this = this
    document.onkeydown = function (e) {
      if (e.keyCode) {
        if (e.keyCode == 13) {
          _this.login()
        }
      }
    }
  }
}
</script>
<style scoped>
.container {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 100%;
  background: #f0f2f5;
}
@media (min-width: 768px) {
  .container {
    /* background-image: url('../../public/img/loginbg (1).jpg'); */
    background: #fff;
    background-repeat: no-repeat;
    background-size: cover;
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.content {
  padding: 32px 0;

  background: white;
  /* -ms-flex: 1 1 0%; */
  /* flex: 1 1 0%; */
}
.main {
  width: 368px;
  margin: 0 auto;
  height: auto;
  /* CHB修改 */
  /* margin-top: 30px; */
}
@media (min-width: 768px) {
  .content {
    padding: 39px 0 24px;
    width: 500px;
    border-radius: 5px;
    height: 400px;
    background: white;
    position: relative;
    top: -40px;
  }
}
.codeImg {
  height: 280px;
  position: relative;
}
.top {
  text-align: center;
}
.header {
  height: 80px;
  line-height: 40px;
}
.logo {
  height: 44px;
  vertical-align: top;
  margin-right: 16px;
}
.title {
  font-size: 29px;
  color: rgba(0, 0, 0, 0.85);
  font-family: 'Myriad Pro', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-weight: 600;
  position: relative;
  top: 2px;
}
.scanQR {
  text-align: center;
  font-size: 16px;
}
.scanWrap {
  margin-top: 30px;
  text-align: center;
  z-index: 1000;
  position: relative;
}
.QRImg {
  width: 70%;
  position: absolute;
  left: 50%;
  top: 56%;
  transform: translate(-50%, -60%);
}
.refresh {
  position: absolute;
  font-size: 13px;
  bottom: 0px;
  left: 50%;
  white-space: nowrap;
  transform: translate(-50%, 0);
  color: #767676;
}
.refresh > span {
  color: #2b85e4;
  cursor: pointer;
}
.desc {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 12px;
  margin-bottom: 40px;
}
.tenant-title {
  margin-bottom: 24px;
  text-align: center;
}
.ivu-form-item {
  margin-bottom: 35px;
  vertical-align: top;
  zoom: 1;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
</style>
